export default __webpack_public_path__ + "static/media/100t.d47fd383.jpg";